import { IconButton, Menu, MenuItem } from '@mui/material';
import { DotsVertical } from 'mdi-material-ui';
import { useState } from 'react';
import { DataGridAction } from './datagrid-types';
import { styled } from '@mui/material/styles';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RowActions = ({ row, actions }: { row: any; actions: DataGridAction[] }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const rowOptionsOpen = Boolean(anchorEl);

  const handleRowOptionsClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleRowOptionsClose = () => {
    setAnchorEl(null);
  };

  const MenuItemLink = styled('a')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    padding: theme.spacing(1.5, 4),
    color: theme.palette.text.primary
  }));

  return (
    <>
      {Boolean(actions.filter(x => !x.alwaysShow).length) && null}
      {actions.filter(x => !x.alwaysShow).length > 0 && (
        <>
          <IconButton size="small" onClick={handleRowOptionsClick}>
            <DotsVertical />
          </IconButton>
          <Menu
            keepMounted
            anchorEl={anchorEl}
            open={rowOptionsOpen}
            onClose={handleRowOptionsClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            PaperProps={{ style: { minWidth: '8rem' } }}>
            {actions
              .filter(action => !action.alwaysShow)
              .map(action => (
                <MenuItem
                  key={action.id}
                  sx={{ p: 0 }}
                  disabled={action.disableCallback?.(row) ?? false}
                  onClick={() => action.clickHandler(row, action)}>
                  <MenuItemLink>
                    {action.icon}
                    {action.text}
                  </MenuItemLink>
                </MenuItem>
              ))}
          </Menu>
        </>
      )}
    </>
  );
};

export default RowActions;
